// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"477451d7","800":"99741259"}[chunkId] + ".chunk.js";
};